/*
  Estilo HALO do seletor de variantes.

  O tema redesenha o seletor (innerHTML do xo-product-variants) depois de cada troca de
  variante. Este script:
  - mantém o painel de tamanhos aberto depois desse redesenho, se o cliente o abriu;
  - devolve o foco ao tamanho ou à cor escolhidos (teclado e leitor de tela);
  - atualiza na hora o modelo escolhido ("HALO 3S - Preto") e o tamanho no botão.

  Tamanho obrigatório (data-halo-require-size, aprovado pelo Pedro):
  - o tema sempre tem uma variante escolhida por baixo (o primeiro tamanho). Enquanto o
    cliente não clica num tamanho, nenhum aparece marcado e a compra fica travada:
    "Adicionar ao carrinho" e o botão da barra fixa abrem o seletor com o aviso em vez de
    adicionar. O clique é segurado antes de chegar ao tema e à Yampi; depois que o tamanho
    é escolhido, o script não interfere em nada. Os arquivos do botão e da Yampi não mudam.
  - Link do guia de tamanho (?variant=...&tamanho=9): o tamanho do link já chega escolhido.
*/
(function () {
  'use strict';

  if (window.haloSeletor) return;
  window.haloSeletor = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function chosenLabel(value) {
    var parts = String(value).split(' - ');
    if (parts.length !== 2) return value;
    // "HALO 3S - Black" (loja global) já vem com o modelo na frente.
    if (/^halo/i.test(parts[0])) return parts[0].replace(/^Halo/, 'HALO') + ' - ' + parts[1];
    return parts[1].replace(/^Halo/, 'HALO') + ' - ' + parts[0];
  }

  function sizeInput(picker) {
    return picker.querySelector('[data-halo-size] input:checked');
  }

  function markChosen(picker, input) {
    if (!input) return;
    var first = picker.dataset.haloSizeChosen !== 'true';
    picker.dataset.haloSizeChosen = 'true';
    var value = picker.querySelector('[data-halo-size-value]');
    if (value) value.textContent = input.value;
    var details = picker.querySelector('[data-halo-size]');
    if (details) details.classList.remove('is-required');
    var msg = picker.querySelector('[data-halo-size-msg]');
    if (msg) msg.hidden = true;
    // Avisa a esteira de compra (assets/halo-esteira.js): libera as etapas seguintes.
    if (first) picker.dispatchEvent(new CustomEvent('halo:tamanho', { bubbles: true }));
  }

  // Abrir e fechar o painel de tamanhos: lembra o estado no próprio seletor.
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details.matches || !details.matches('[data-halo-size]')) return;
    var picker = details.closest('.halo-picker');
    if (picker) picker.dataset.haloSizeOpen = details.open ? 'true' : 'false';
  }, true);

  // Clique num tamanho (inclusive no que o tema já deixa marcado) conta como escolha.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.halo-picker [data-halo-size] .xo-field-toggle');
    if (!toggle) return;
    var picker = toggle.closest('.halo-picker');
    var input = toggle.querySelector('input');
    // O rádio só fica marcado depois do clique; espera o navegador marcar.
    setTimeout(function () {
      markChosen(picker, input && input.checked ? input : sizeInput(picker));
    }, 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var picker = input.closest('.halo-picker');
    if (!picker) return;
    picker.dataset.haloFocus = input.getAttribute('xo-option-value-id') || '';

    if (input.closest('[data-halo-size]')) {
      markChosen(picker, input);
      return;
    }
    var chosen = picker.querySelector('[data-halo-chosen]');
    if (chosen && input.closest('.halo-picker__swatches')) chosen.textContent = chosenLabel(input.value);
  });

  function restore(picker) {
    var details = picker.querySelector('[data-halo-size]');
    if (details && picker.dataset.haloSizeOpen === 'true' && !details.open) details.open = true;
    if (picker.dataset.haloSizeChosen === 'true') {
      var value = picker.querySelector('[data-halo-size-value]');
      var input = sizeInput(picker);
      if (value && input) value.textContent = input.value;
    }
    var id = picker.dataset.haloFocus;
    if (!id) return;
    picker.dataset.haloFocus = '';
    if (picker.contains(document.activeElement)) return;
    var option = picker.querySelector('[xo-option-value-id="' + id + '"]');
    var target = option && option.closest('[tabindex]');
    if (target) target.focus({ preventScroll: true });
  }

  function watch(picker) {
    if (picker.haloWatched) return;
    picker.haloWatched = true;
    new MutationObserver(function () {
      restore(picker);
    }).observe(picker, { childList: true });
  }

  // O cliente escolheu o tamanho no guia (assets/halo-guia-ferramenta.js monta o link).
  function fromGuide(picker) {
    var wanted;
    try { wanted = new URLSearchParams(window.location.search).get('tamanho'); } catch (e) { return; }
    if (!wanted || picker.dataset.haloSizeChosen === 'true') return;
    var input = sizeInput(picker);
    if (input && input.value === wanted) markChosen(picker, input);
  }

  function init() {
    document.querySelectorAll('.halo-picker').forEach(function (picker) {
      watch(picker);
      fromGuide(picker);
    });
  }

  // Trava da compra sem tamanho escolhido
  function pendingPicker() {
    var picker = document.querySelector('.halo-picker[data-halo-require-size]');
    if (!picker || picker.dataset.haloSizeChosen === 'true') return null;
    if (!picker.querySelector('[data-halo-size]')) return null;
    return picker;
  }

  // Só os botões que compram o produto desta página: o formulário de compra dentro da mesma
  // seção de produto do seletor e o botão da barra fixa. (O HTML do tema abre um formulário
  // dentro de outro e o navegador descarta o de dentro, então o id dele não serve.)
  function buysThisProduct(el, picker) {
    if (el.closest('[data-sticky-atc-submit]')) return true;
    var form = el.closest('form[action*="/cart/add"]');
    var product = picker.closest('xo-product');
    return !!(form && product && product.contains(form));
  }

  function requireSize(picker) {
    var details = picker.querySelector('[data-halo-size]');
    if (details) {
      details.open = true;
      picker.dataset.haloSizeOpen = 'true';
      details.classList.add('is-required');
    }
    var msg = picker.querySelector('[data-halo-size-msg]');
    if (msg) {
      msg.hidden = false;
      msg.textContent = '';
      msg.textContent = msg.dataset.text || '';
    }
    var header = document.querySelector('[data-halo-header-bar]') || document.querySelector('.xo-header__inner');
    var offset = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 24;
    var rect = picker.getBoundingClientRect();
    if (rect.top < offset || rect.bottom > window.innerHeight) {
      window.scrollTo({ top: rect.top + window.pageYOffset - offset, behavior: reduce ? 'auto' : 'smooth' });
    }
    var first = picker.querySelector('.halo-picker__sizes [tabindex]');
    if (first) first.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('xo-cart-add, [name="add"], [type="submit"], [data-sticky-atc-submit]');
    if (!button) return;
    var picker = pendingPicker();
    if (!picker || !buysThisProduct(button, picker)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    requireSize(picker);
  }, true);

  // Clique numa etapa apagada da esteira de compra: abre os tamanhos com o aviso.
  document.addEventListener('halo:pedir-tamanho', function (e) {
    var picker = e.target.closest && e.target.closest('.halo-picker');
    if (picker && picker.querySelector('[data-halo-size]')) requireSize(picker);
  });

  document.addEventListener('submit', function (e) {
    var picker = pendingPicker();
    if (!picker || !buysThisProduct(e.target, picker)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    requireSize(picker);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
